import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CourseSearchFilterPill } from '../../models/course-search-filter.models';
import { CloseModalSvgComponent } from '@uc/shared/svg';

@Component({
	selector: 'uc-course-search-filter-pill',
	templateUrl: './course-search-filter-pill.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CloseModalSvgComponent],
})
export class CourseSearchFilterPillComponent {
	pill = input.required<CourseSearchFilterPill>();

	removePill = output<CourseSearchFilterPill>();
}
